import {
  SESSION_CLEAR,
  SESSION_LOADING,
  SESSION_SET_DATA,
} from "../actionNames";
import { post } from "../../httpFunctions";
import { processSignIn } from "../../session";

export function setSession(data) {
  return (dispatch) => {
    dispatch({
      type: SESSION_SET_DATA,
      data,
    });
  };
}

export function cleanSession() {
  return (dispatch) =>
    dispatch({
      type: SESSION_CLEAR,
    });
}

export const initAuth = () => async (dispatch) => {
  dispatch({ type: SESSION_LOADING });
  try {
    const response = await post("/auth/refresh");
    const token = response.data.data.token;
    if (token) {
      await processSignIn(response);
      dispatch(setSession(response.data.data));
    } else {
      dispatch(cleanSession());
    }
  } catch {
    dispatch(cleanSession());
  }
};
